// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"styles_Checkbox__26smi","LabelText":"styles_LabelText__2XsX0"};